import axios from "axios";
import { EventBus } from "./eventBus";

export default {
  namespaced: true,

  state: {
    cartData: null
  },

  getters: {
    projectCart: state => state.cartData
  },

  mutations: {
    setCartData(state, cart) {
      state.cartData = cart;
      console.log("=====>",state.cartData);
    }
  },

  actions: {
    getCartData({ commit },pData={}) {
        console.log("here...cart");
        var showroom =  JSON.parse(localStorage.getItem('my_item'))
        showroom= parseInt(showroom.showroom)||0;
        var project = parseInt( localStorage.getItem('project'))||0;
        var temp_project_id= localStorage.getItem('cart_id');
        pData.project=project
        if(temp_project_id){
            pData.temp_project_id=temp_project_id;
            pData.is_cart=true;
            pData.showroom=showroom
        }

      axios
        .get("/api/projectCart",{
            params:pData
        })
        .then(response => {
            if(temp_project_id){
                if(localStorage.getItem('cart_id')){
                    commit("setCartData", response.data.data);
                }
            }else{
                commit("setCartData", response.data.data);
            }

        })
        .catch(() => {
         // localStorage.removeItem("authToken");
        });
    },
    removeCartData({commit},data){
        commit("setCartData", null);
    },
    addCartRequest({ commit }, data) {
      commit("setErrors", {}, { root: true });
      var showroom =  JSON.parse(localStorage.getItem('my_item'))
      showroom= parseInt(showroom.showroom)||0;
      data.showroom = showroom
      data.action = "cart";
      return axios
        .post( "/api/projectCart/sync_to_cart", data)
        .then(response => {
            commit("setCartData", response.data.data);
            let toaster=data.toast=="no" ? false : true;
            if(toaster==true){
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
            }
        }).catch(err=>{
            Toast.fire({
            icon: 'error',
            title: response.data.message
        });
        });;
    },
    addBulkCartRequest({commit},data){ 
        commit("setErrors", {}, { root: true });
        var showroom =  JSON.parse(localStorage.getItem('my_item'))
      showroom= parseInt(showroom.showroom)||0;
      data.showroom = showroom
        data.action="cart";
        return axios
          .post( "/api/projectCart/sync_to_bulk_cart", data)
          .then(response => {
           commit("setCartData", response.data.data);
          Toast.fire({
              icon: 'success',
              title: response.data.message
          });
          }).catch(err=>{
              Toast.fire({
              icon: 'error',
              title: response.data.message
          });
          });
    },
    updateCartRequest({commit},data){
        commit("setErrors", {}, { root: true });
        var showroom =  JSON.parse(localStorage.getItem('my_item'))
      showroom= parseInt(showroom.showroom)||0;
      data.showroom = showroom
        return axios
          .post( "/api/projectCart/update_cart", data)
          .then(response => {
           commit("setCartData", response.data.data);
          Toast.fire({
              icon: 'success',
              title: response.data.message
          });
          }).catch(err=>{
              Toast.fire({
              icon: 'error',
              title: response.data.message
          });
          });
    },
    addProjectToCartRequest({commit},data){
        commit("setErrors", {}, { root: true });
        var showroom =  JSON.parse(localStorage.getItem('my_item'))
      showroom= parseInt(showroom.showroom)||0;
      data.showroom = showroom
        return axios
          .post( "/api/projectCart/update_project_cart", data)
          .then(response => {
           commit("setCartData", response.data.data);
           localStorage.removeItem('cart_id');
           console.log("emitting event from update_project_cart");
           EventBus.$emit("cart-updated");
          Toast.fire({
              icon: 'success',
              title: response.data.message
          });
          }).catch(err=>{
              Toast.fire({
              icon: 'error',
              title: response.data.message
          });
          });
    },
    removeCartRequest({ commit },data) {
      commit("setErrors", {}, { root: true });
      let params= data.params
      var showroom =  JSON.parse(localStorage.getItem('my_item'))
      showroom= parseInt(showroom.showroom)||0;
      params.showroom = showroom
      return axios
        .delete("/api/cart/destroy/"+data.id, {params})
        .then(response => {
          if(response.data){
            commit("setCartData", response.data.data);
          }
        });
    },

    async projectCreatRequest({commit},data){
        commit("setErrors", {}, { root: true });
        var showroom =  JSON.parse(localStorage.getItem('my_item'))
      showroom= parseInt(showroom.showroom)||0;
      data.showroom = showroom
      return axios
        .post("/api/projectCart", data)
        .then(response => {
          if(response.data){
            console.log("response.data======//", response.data);
            localStorage.setItem("project", response.data.data);
            return response.data.data;
          }
        });
    }


  }
};
